import Notification from "./notification.repository";
import NotificationMessageBuilder from "./services/notificationMessageBuilder";
import Notifications from "./services/notifications";

export default angular.module('app.notification', [])
    .service('NotificationMessageBuilder', NotificationMessageBuilder)
    .service('Notifications', Notifications)
    .service('Notification', Notification)
    .name;

